export const DEVICE_ORDER = ['desktop', 'mobile'];

export const DEVICE_PRESETS = {
  desktop: {
    id: 'desktop',
    label: 'Desktop',
    description: '≥ 1200px',
    width: 1200,
    height: 780,
    containerWidth: 1280,
    grapesName: 'Desktop',
    widthMedia: '',
  },
  mobile: {
    id: 'mobile',
    label: 'Mobile',
    description: '≤ 480px',
    width: 414,
    height: 880,
    containerWidth: 460,
    grapesName: 'Mobile',
    widthMedia: '414px',
  },
};

export const DEFAULT_DEVICE_KEY = DEVICE_ORDER[0];

export const DEVICE_TO_GRAPES = DEVICE_ORDER.reduce((acc, key) => {
  const preset = DEVICE_PRESETS[key];
  if (preset?.grapesName) acc[key] = preset.grapesName;
  return acc;
}, {});

export const GRAPES_TO_DEVICE = Object.entries(DEVICE_TO_GRAPES).reduce(
  (acc, [deviceKey, grapesName]) => {
    if (grapesName) acc[grapesName] = deviceKey;
    return acc;
  },
  {}
);

export const normalizeDeviceKey = value => {
  if (!value) return DEFAULT_DEVICE_KEY;
  const key = String(value).toLowerCase();
  return DEVICE_ORDER.find(deviceKey => deviceKey === key) || DEFAULT_DEVICE_KEY;
};

export const ensureDeviceKey = key =>
  DEVICE_PRESETS[key] ? key : DEFAULT_DEVICE_KEY;
